import React, { useState } from "react";
import "./chat-reactions.css";
import EmojiPickerNative from "../../components/Textarea/Emojis/emoji-picker-native";
import { Plus } from "lucide-react";
import { ReactionEmoji } from "./reaction-emoji";

const QUICK_EMOJIS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

interface Props {
    userReaction?: string | null;
    onReact: (emoji: string) => void;
    onClose?: () => void;
    position?: "top" | "bottom" | "center";
    align?: "left" | "right" | "center";
}

export const ChatReactionPicker: React.FC<Props> = ({
    userReaction,
    onReact,
    onClose,
    position = "top",
    align = "left",
}) => {
    const [showFullPicker, setShowFullPicker] = useState(false);

    const handleSelect = (emoji: string) => {
        onReact(emoji);
        setShowFullPicker(false);
        if (onClose) onClose();
    };

    return (
        <div
            className={`chat-reaction-picker-container ${position} ${align}`}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
        >
            <div className="chat-reaction-picker-bubble">
                {QUICK_EMOJIS.map((emoji) => (
                    <button
                        key={emoji}
                        type="button"
                        className={`chat-reaction-picker-btn ${userReaction === emoji ? "active" : ""}`}
                        onClick={() => handleSelect(emoji)}
                        title={emoji}
                    >
                        <ReactionEmoji emoji={emoji} size={22} />
                    </button>
                ))}
                <button
                    type="button"
                    className="chat-reaction-picker-btn chat-reaction-more-btn"
                    onClick={() => setShowFullPicker(!showFullPicker)}
                    title="Mais reações"
                >
                    <Plus size={18} />
                </button>
            </div>

            {showFullPicker && (
                <div className="chat-reaction-native-picker-wrapper">
                    <EmojiPickerNative
                        show={showFullPicker}
                        setShow={setShowFullPicker}
                        onSelect={(emoji) => handleSelect(emoji)}
                    />
                </div>
            )}
        </div>
    );
};
